import { render } from "./App.vue?vue&type=template&id=4b8a8ebc"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4b8a8ebc&lang=scss"

import exportComponent from "C:\\Users\\paulinho\\Documents\\GitHub\\liscomp_website_vue3_cli\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__